import { AIMagic } from "@/assets";
import { useProfile } from "@/context/useProfileProps";
import React from "react";

import { AiSummaryActionType } from "@/components/profile/profileSummary/types";

type SummaryBtnProps = {
  className?: string;
  type: AiSummaryActionType;
  handleAiBtnClick: (type: AiSummaryActionType) => void;
};

const SummaryBtn = ({
  className = "w-max",
  type,
  handleAiBtnClick,
}: SummaryBtnProps) => {
  const {
    translation: { profileSummary },
  } = useProfile();
  return (
    <div className={className}>
      {type === "generate" ? (
        <button
          type="button"
          className="generate-btn py-1 pl-3 pr-2 md:py-2"
          onClick={() => handleAiBtnClick(type)}
        >
          <span>
            <AIMagic height={24} width={24} />
          </span>
          {profileSummary.generateByAI}
        </button>
      ) : (
        <button
          className="text-brand-primary whitespace-nowrap text-xs font-semibold"
          type="button"
          onClick={() => handleAiBtnClick(type)}
        >
          View Options
        </button>
      )}
    </div>
  );
};

export default SummaryBtn;
